import { Col as AntdCol } from "antd";
import { ColProps, defaultProps } from "./Col.type";
import styles from "./Col.module.scss";

export const Col = (props: ColProps) => {
	const { children, ...attributes } = { ...defaultProps, ...props }

	return (
		<AntdCol {...attributes} className={styles.Col}>
			{children}
		</AntdCol>
	)
};
